const COMMON_SIDEBETS = {
  ONE_TO_FIVE: 'Joker_1_5',
  SIX_TO_TEN: 'Joker_6_10',
  ELEVEN_TO_FIFTEEN: 'Joker_11_15',
  SIXTEEN_TO_TWENTYFIVE: 'Joker_16_25',
  TWENTYSIX_TO_THIRTY: 'Joker_26_30',
  THIRTYONE_TO_THIRTYFIVE: 'Joker_31_35',
  THIRTYSIX_TO_FORTY: 'Joker_36_40',
  FORTYONE_OR_MORE: 'Joker_41',
} as const;

export const ANDAR_BAHAR_BET_TYPES = {
  ANDAR: 'AndarBet',
  BAHAR: 'BaharBet',
  ...COMMON_SIDEBETS,
} as const;

export const OTT_ANDAR_BAHAR_BET_TYPES = {
  ANDAR_FIRST: 'AndarFirstBet',
  BAHAR_FIRST: 'BaharFirstBet',
  ANDAR_SECOND: 'AndarSecondBet',
  BAHAR_SECOND: 'BaharSecondBet',
  ...COMMON_SIDEBETS,
} as const;

export type ABBetTypeKey = keyof typeof ANDAR_BAHAR_BET_TYPES;
export type ABBetType = typeof ANDAR_BAHAR_BET_TYPES[ABBetTypeKey]

export type OTTABBetTypeKey = keyof typeof OTT_ANDAR_BAHAR_BET_TYPES;
export type OTTABBetType = typeof OTT_ANDAR_BAHAR_BET_TYPES[OTTABBetTypeKey]
